import { createSlice } from "@reduxjs/toolkit";
const initialState = { address: null, provider: null, signer: null };
const walletSlice = createSlice({ name: "wallet", initialState, reducers: {
  setWallet(state, action) { return {...state, ...action.payload}; },
  clearWallet() { return initialState; }
}});
export const { setWallet, clearWallet } = walletSlice.actions;
export default walletSlice.reducer;
